<template lang="pug">
.relative.d-flex.flex-column.gap-24.gr-6.align-start
  input.pointer-events-none.d-none(
    ref="fileInput"
    type="file"
    :multiple="multiple"
    :accept="accept"
    @change="onFilesPicked"
  )

  slot(v-bind="{ loading, pickFile, dropFiles }")
    d-drag-and-drop.cursor-pointer.full-width(
      :loading="loading"
      @click="pickFile"
      @drop-files="dropFiles"
    )
    dv-btn(
      v-if="!hideButton"
      :loading="loading"
      large
      dark
      @click="pickFile"
    ): p.ui-body-1 Загрузить файл
</template>

<script>
import DDragAndDrop from './DDragAndDrop.vue';
import DvBtn from '../../buttons/DvBtn.vue';

export default {
  components:  { DDragAndDrop, DvBtn },
  props: {
    loading: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: 'image/*' },
    hideButton: { type: Boolean, default: false },
    value: {
      type: [Array, Object],
      default: undefined,
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
    },
    files(val) {
      if (!val?.length) {
        this.$refs.fileInput.value = '';
      }

      this.$emit('input', val);
    },
  },
  computed: {
    files: {
      get() {
        const { inputValue } = this;
        return [].concat(inputValue || []);
      },
      set(val) {
        const { multiple } = this;
        const files = [].concat(val || []);
        const first = 0;

        this.inputValue = multiple ? files : files.at(first);
      },
    },
  },
  methods: {
    input(files) {
      this.files = [...files || []];
    },
    pickFile() {
      this.$refs.fileInput.click();
    },
    async onFilesPicked(e) {
      const { files } = e?.target;

      this.input(files);
    },
    dropFiles(e) {
      const { files } = e?.dataTransfer;

      this.input(files);
    },
  },
};
</script>
